import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

const BACKEND_LIMIT = 50;

export const samePhoneAccountsQueryKeys = {
  all: ['similar-accounts'] as const,
  list: (phone: string | null | undefined, brand: string, userId: string) =>
    [...samePhoneAccountsQueryKeys.all, phone, brand, userId] as const,
};

export function useSamePhoneAccounts(user: App.User, brand: string) {
  return useQuery({
    queryKey: samePhoneAccountsQueryKeys.list(user.phone, brand, user.id_member),
    queryFn: async ({ signal }) => {
      if (!user.phone) {
        return [];
      }

      const response = await UsersService.getUsers(
        {
          filter: user.phone,
          limit: BACKEND_LIMIT,
          offset: 0,
          brand,
        },
        { signal },
      );

      return response.filter((account: App.UserSummary) => account.id_member !== user.id_member);
    },
    enabled: !!user.phone,
  });
}

export { BACKEND_LIMIT as SAME_PHONE_ACCOUNTS_BACKEND_LIMIT };
